<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <!-- <v-row>
            <v-col sm="12">
              <v-text-field 
                label="Tracked Bill ID" 
                v-model="selectedTrackedBillAgency.TrackedBillID"
                type="number"
                :rules="[v => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col sm="12">
              <LuAgency
                label="Agency"
                v-model="selectedTrackedBillAgency.AgencyID"
                :rules="[(v) => !!v || 'required']"
              >
                <template v-slot:item="{ item, index }">
                  <span>
                    {{ item.Name }} - ({{ item.Number }} - {{ item.Abr }})
                  </span></template
                >
                <template v-slot:selection="{ item, index }">
                  <span>
                    {{ item.Name }} - ({{ item.Number }} - {{ item.Abr }})
                  </span></template
                >
              </LuAgency>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuTrackedBillPermission
                label="Permission"
                v-model="selectedTrackedBillAgency.TrackedBillPermissionID"
                :currentUserPermissionID="currentUserPermissionID"
                :rules="[(v) => !!v || 'required']"
              ></LuTrackedBillPermission>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveTrackedBillAgencyDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBillAgency from '@classes/TrackedBillAgency'
import LuAgency from '@components/select/a-single/LuAgency'
import LuTrackedBillPermission from '@components/select/single/LuTrackedBillPermission'

export default {
  components: { LuAgency, LuTrackedBillPermission },
  data: () => ({
    dialog: false,
    valid: true,
    selectedTrackedBillAgency: new TrackedBillAgency(),
    modalText: '',
  }),
  props: {
    trackedBillID: {
      type: Number,
      required: true,
    },
    currentUserPermissionID: {
      type: Number,
      required: true,
    },
  },
  created() {},
  computed: {
    ...get('trackedBillAgency', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('trackedBillAgency', ['saveTrackedBillAgency']),
    async validate() {
      this.$refs.form.validate()
    },
    editTrackedBillAgency(entry) {
      this.selectedTrackedBillAgency = new TrackedBillAgency(entry)
      this.modalText = 'Edit Agency Permissions'
      this.dialog = !this.dialog
    },
    addTrackedBillAgency() {
      this.modalText = 'Add Agency Permissions'
      this.selectedTrackedBillAgency = new TrackedBillAgency()
      this.selectedTrackedBillAgency.TrackedBillID = this.trackedBillID
      this.dialog = !this.dialog
    },
    saveTrackedBillAgencyDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveTrackedBillAgency(
            this.selectedTrackedBillAgency.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedTrackedBillAgency = new TrackedBillAgency()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedTrackedBillAgency = new TrackedBillAgency()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
